import { getTimeInputValueFromString, getDateInputValueFromString } from "../utils/dateUtils";
import * as ScheduleFormFields from "../constants/liveSessionScheduleFormFields";
import { getLang } from "../../../../js/utils/functions";

export const scheduleFormFieldsInitialValueMapper = {
  [ScheduleFormFields.TITLE]: (data) => data?.[ScheduleFormFields.TITLE],
  [ScheduleFormFields.DATE]: (data) =>
    getDateInputValueFromString(data?.[ScheduleFormFields.SCHEDULED_AT]),
  [ScheduleFormFields.TIME]: (data) =>
    getTimeInputValueFromString(data?.[ScheduleFormFields.SCHEDULED_AT]),
  [ScheduleFormFields.SCHEDULED_AT]: (data) =>
    /* eslint-disable-next-line react/destructuring-assignment */
    data?.[ScheduleFormFields.SCHEDULED_AT]
      ? /* eslint-disable-next-line react/destructuring-assignment */
        new Date(data?.[ScheduleFormFields.SCHEDULED_AT])
      : null,
  [ScheduleFormFields.LANGUAGE]: (data) => data?.[ScheduleFormFields.LANGUAGE] || getLang,
  [ScheduleFormFields.DESCRIPTION]: (data) => data?.[ScheduleFormFields.DESCRIPTION],
};
